import { Button, Modal } from '@birdi/components-common';
import BriefSVG from '@birdi/icons/brief.svg';
import { next } from '@birdi/theme';
import { css } from '@emotion/react';
import { useState } from 'react';
import { stroot, maps as mapsApi } from '@birdi/js-sdk';
import FolderSelect from './folder-select';

interface MoveToFolderFormProps {
  currentFolderId: string | null;
  onSuccess: () => void;
  mapId: string;
}

const MoveToFolderForm = ({ currentFolderId, onSuccess, mapId }: MoveToFolderFormProps) => {
  const [selectedFolder, setSelectedFolder] = useState<any>({ value: currentFolderId });

  const onSubmit = async () => {
    await mapsApi.updateMap(stroot('k1665s'), mapId, { folderId: selectedFolder?.value || null });
    onSuccess();
  };

  return (
    <form id="move-to-folder-form" css={next.form.root} onSubmit={(e) => {
      e.preventDefault();
      onSubmit();
    }}>
      <label css={next.form.field.root}>
        <span>
          Please choose the folder you want to move this map to it:
        </span>
        <FolderSelect
          onChange={(option) => {
            setSelectedFolder(option);
          }}
          defaultValue={selectedFolder?.value}
          placeholder="Select folder"
          isClearable={true}
        />
      </label>
    </form>
  );
};

export interface MoveToFolderModalProps {
  open: boolean;
  onChange: (value: boolean) => void;
  currentFolderId: string | null;
  mapId: string;
}

export const MoveToFolderModal = ({ open, onChange, currentFolderId, mapId }: MoveToFolderModalProps) => {
  return (
    <Modal.Root open={open} onOpenChange={onChange}>
      <Modal.Header>
        Move map to folder
      </Modal.Header>

      <Modal.Body>
        <div css={css`
          overflow: visible;
          position: relative;
          z-index: 1;
        `}>
          <MoveToFolderForm
            currentFolderId={currentFolderId}
            onSuccess={() => {
              // Capture URL before closing modal to prevent race condition
              const currentUrl = window.location.href;
              onChange(false);
              // Force reload to the captured URL
              window.location.href = currentUrl;
            }}
            mapId={mapId}
          />
        </div>
      </Modal.Body>

      <Modal.Footer buttons>
        <Button variant='outline' onClick={() => onChange(false)}>Cancel</Button>
        <Button variant='solid' type="submit" form="move-to-folder-form">Confirm</Button>
      </Modal.Footer>
    </Modal.Root>
  );
};
